import type { ComponentProps } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { INTAKE_FORM_ROUTE } from "@/features/intake-form/router";
import { FullscreenAlert, VideoCameraIcon } from "@/shared/ui";

export const PriorConsultationRequired = ({
  open,
  onOpenChange,
}: ComponentProps<typeof FullscreenAlert.Root>) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    return navigate(INTAKE_FORM_ROUTE.SCHEDULE_VIDEO_CONSULTATION);
  };

  return (
    <FullscreenAlert.Root open={open} onOpenChange={onOpenChange}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={VideoCameraIcon}>
          <FullscreenAlert.Title>
            {t`Prior consultation with provider required`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Due to your current medical situation, at this time we cannot make a refill request, you must see a provider first.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action onClick={handleContinue}>
            {t`Continue`}
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
